import { CELL_TYPES } from './cellSchema';

const escapeHtml = (str) => {
  if (!str) return '';
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

const preserveLineBreaks = (html) => {
  if (!html) return '';
  if (!html.includes('<p>') && !html.includes('<div>') && !html.includes('<br>')) {
    return html.replace(/\n/g, '<br>');
  }
  return html;
};

const renderButton = (cell) => {
  const { content = 'Button', buttonUrl = '#', styles = {}, height = 50, buttonWidth, buttonHeight } = cell;

  const bg = styles.backgroundColor || '#7a6a55';
  const color = styles.color || '#ffffff';
  const padding = styles.padding || '12px 20px';
  const fontSize = styles.fontSize || '14px';
  const fontWeight = styles.fontWeight || '600';
  const borderRadius = styles.borderRadius || '10px';
  const fontFamily = styles.fontFamily || 'Arial, sans-serif';
  const border =
    styles.borderColor && styles.borderColor !== 'transparent'
      ? `1px solid ${styles.borderColor}`
      : '0';
  const alignAttr =
    styles.textAlign === 'left' ? 'left' : styles.textAlign === 'right' ? 'right' : 'center';
  const escapedUrl = escapeHtml(buttonUrl);
  const escapedText = escapeHtml(content);

  const btnW = buttonWidth != null && buttonWidth !== '' ? buttonWidth : 40;
  const btnH = buttonHeight != null && buttonHeight !== '' ? buttonHeight : 15;
  const sizeStyle = `min-width: ${btnW}px; height: ${btnH}px;`;
  const vCenterPadding = `0 20px`;

  return `<table cellpadding="0" cellspacing="0" border="0" width="100%" data-btn-width="${btnW}" data-btn-height="${btnH}" style="margin: 0; border-collapse: collapse;">
    <tr>
      <td align="${alignAttr}" style="padding: 8px 0; border: none;">
        <!--[if mso]>
        <table cellpadding="0" cellspacing="0" border="0" align="${alignAttr}"><tr>
        <td bgcolor="${bg}" style="padding: ${vCenterPadding}; text-align: center; vertical-align: middle; border: ${border}; ${sizeStyle}">
        <a href="${escapedUrl}" target="_blank" style="color: ${color}; text-decoration: none; font-size: ${fontSize}; font-weight: ${fontWeight}; font-family: ${fontFamily};">${escapedText}</a>
        </td></tr></table>
        <![endif]-->
        <!--[if !mso]><!-->
        <a href="${escapedUrl}" target="_blank" rel="noopener noreferrer" style="display: inline-block; padding: ${vCenterPadding}; background-color: ${bg}; color: ${color}; text-decoration: none; font-size: ${fontSize}; font-weight: ${fontWeight}; border-radius: ${borderRadius}; border: ${border}; font-family: ${fontFamily}; line-height: ${btnH}px; text-align: center; ${sizeStyle}">${escapedText}</a>
        <!--<![endif]-->
      </td>
    </tr>
  </table>`;
};

const renderDivider = (cell) => {
  const { dividerColor = '#7a6a55', dividerThickness = 2 } = cell;
  return `<table width="100%" cellpadding="0" cellspacing="0" border="0" data-comp="divider" data-color="${escapeHtml(
    dividerColor,
  )}" data-thickness="${dividerThickness}" style="width: 100%; border-collapse: collapse;">
    <tr>
      <td height="5" style="height: 5px; font-size: 5px; line-height: 5px; padding: 0; mso-line-height-rule: exactly;">&nbsp;</td>
    </tr>
    <tr>
      <td height="${dividerThickness}" bgcolor="${dividerColor}" style="height: ${dividerThickness}px; background-color: ${dividerColor}; font-size: 1px; line-height: 1px; padding: 0;">&nbsp;</td>
    </tr>
    <tr>
      <td height="5" style="height: 5px; font-size: 5px; line-height: 5px; padding: 0; mso-line-height-rule: exactly;">&nbsp;</td>
    </tr>
  </table>`;
};

const SOCIAL_ICON_BASE_URL = 'https://hudini-assets-staging.s3.ap-south-1.amazonaws.com/email-assets';
const SOCIAL_ICON_URLS = {
  linkedin: `${SOCIAL_ICON_BASE_URL}/LinkedIn-Transparent.png`,
  facebook: `${SOCIAL_ICON_BASE_URL}/FB-transparent.png`,
  twitter: `${SOCIAL_ICON_BASE_URL}/X-transparent.png`,
  instagram: `${SOCIAL_ICON_BASE_URL}/instagram-transparent.png`,
  youtube: `${SOCIAL_ICON_BASE_URL}/YT-transparent.png`,
};
const getSocialIconUrl = (key) => SOCIAL_ICON_URLS[key] || '';

const renderSocial = (cell) => {
  const {
    socialLinks = {},
    socialOrder = ['linkedin', 'facebook', 'twitter', 'instagram', 'youtube'],
    iconColor = '#EED191',
    iconSpacing = 10,
    styles = {},
  } = cell;

  const SOCIAL_ALT = {
    linkedin: 'in',
    facebook: 'f',
    twitter: 'X',
    instagram: 'IG',
    youtube: 'YT',
  };

  const SOCIAL_TITLES = {
    linkedin: 'LinkedIn',
    facebook: 'Facebook',
    twitter: 'X/Twitter',
    instagram: 'Instagram',
    youtube: 'YouTube',
  };

  const activeLinks = socialOrder
    .filter((key) => socialLinks[key] && socialLinks[key].trim())
    .map((key) => ({
      key,
      url: socialLinks[key],
      alt: SOCIAL_ALT[key] || key.charAt(0).toUpperCase(),
      title: SOCIAL_TITLES[key] || key,
      iconSrc: getSocialIconUrl(key),
    }));

  if (activeLinks.length === 0) return '';

  const iconsHtml = activeLinks
    .map(
      ({ key, url, alt, title, iconSrc }) =>
        `<td style="padding: 0 ${iconSpacing / 2}px;" align="center" valign="middle">
          <table cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse;">
            <tr>
              <td bgcolor="${iconColor}" width="32" height="32" align="center" valign="middle" style="width: 32px; height: 32px; background-color: ${iconColor}; border-radius: 50%; text-align: center; vertical-align: middle; padding: 0; line-height: 32px; mso-line-height-rule: exactly;">
                <a href="${escapeHtml(url)}" data-social="${key}" target="_blank" rel="noopener noreferrer" title="${escapeHtml(title)}" style="display: block; width: 32px; height: 32px; line-height: 32px; text-decoration: none; text-align: center; color: #ffffff; font-size: 14px; font-weight: bold; font-family: Arial, sans-serif;"><img src="${iconSrc}" alt="${escapeHtml(alt)}" width="18" height="18" border="0" style="display: inline-block; vertical-align: middle; border: 0; outline: none;" /></a>
              </td>
            </tr>
          </table>
        </td>`,
    )
    .join('');

  const socialDataJson = escapeHtml(JSON.stringify(socialLinks));
  const orderStr = socialOrder.join(',');

  return `<table cellpadding="0" cellspacing="0" border="0" align="${
    styles.textAlign || 'center'
  }" data-comp="social" data-links='${socialDataJson}' data-color="${escapeHtml(
    iconColor,
  )}" data-spacing="${iconSpacing}" data-order="${orderStr}" style="margin: 0 auto; border-collapse: collapse;">
    <tr>${iconsHtml}</tr>
  </table>`;
};

const renderImage = (cell) => {
  const { imageUrl = '', imageAlt = 'Image', width, height, redirectUrl = '' } = cell;
  if (!imageUrl) return '';

  const imgTag = `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(imageAlt)}" width="${Math.round(width)}" height="${Math.round(height)}" border="0" style="display: block; border: 0; outline: none; width: ${Math.round(width)}px; height: ${Math.round(height)}px; -ms-interpolation-mode: bicubic;" />`;

  if (redirectUrl) {
    return `<a href="${escapeHtml(redirectUrl)}" target="_blank" style="text-decoration: none; border: 0;">${imgTag}</a>`;
  }
  return imgTag;
};

const renderText = (cell) => {
  let content = cell?.content || '';
  content = content
    ?.replace(/^[\s\n\r]+/, '')
    ?.replace(/[\s\n\r]+$/, '')
    ?.replace(/^(<br\s*\/?>)+/gi, '')
    ?.replace(/(<br\s*\/?>)+$/gi, '');
  return preserveLineBreaks(content);
};

/* ── Helpers: find child components inside TABLE cells ── */
const findChildrenInTable = (tableCell, allCells) => {
  if (!tableCell.tableModel) return [];
  return allCells.filter((c) => {
    if (c.id === tableCell.id || c.type === CELL_TYPES.TABLE) return false;
    const cx = c.x + c.width / 2, cy = c.y + c.height / 2;
    return cx >= tableCell.x && cx <= tableCell.x + tableCell.width &&
           cy >= tableCell.y && cy <= tableCell.y + tableCell.height;
  });
};

const getGridCellIndex = (comp, tableCell) => {
  const tm = tableCell.tableModel;
  const nR = tm.grid.length, nC = tm.grid[0]?.length || 1;
  const cw = (tm.colWidths || []).map((v) => (v != null ? v : 100 / nC));
  const rh = (tm.rowHeights || []).map((v) => (v != null ? v : 100 / nR));
  const cPx = [0]; for (let i = 0; i < nC; i++) cPx.push(cPx[i] + (cw[i] / 100) * tableCell.width);
  const rPx = [0]; for (let i = 0; i < nR; i++) rPx.push(rPx[i] + (rh[i] / 100) * tableCell.height);
  const cx = comp.x + comp.width / 2 - tableCell.x;
  const cy = comp.y + comp.height / 2 - tableCell.y;
  let ci = nC - 1; for (let k = 0; k < nC; k++) { if (cx < cPx[k + 1]) { ci = k; break; } }
  let ri = nR - 1; for (let k = 0; k < nR; k++) { if (cy < rPx[k + 1]) { ri = k; break; } }
  return { ri, ci };
};

/* ── Render TABLE cell as Outlook-compatible HTML with child components ── */
const renderTableWithChildren = (cell, childCells) => {
  const tm = cell.tableModel;
  if (!tm) return '';
  const bw = tm.tableBorderWidth != null ? tm.tableBorderWidth : 1;
  const bc = tm.tableBorderColor || '#d0d5dd';
  const bsty = tm.tableBorderStyle || 'solid';
  const nR = tm.grid.length, nC = tm.grid[0]?.length || 1;
  const colWidths = tm.colWidths || [];
  const rowHeights = tm.rowHeights || [];

  // Map children to grid cells
  const childMap = {};
  (childCells || []).forEach((child) => {
    const { ri, ci } = getGridCellIndex(child, cell);
    const key = `${ri}-${ci}`;
    if (!childMap[key]) childMap[key] = [];
    childMap[key].push(child);
  });

  const loopConds = tm.tableLoopConditions || [];

  const buildTableRow = (ri) => {
    const rhPct = rowHeights[ri];
    const rowH = rhPct ? Math.round((rhPct / 100) * cell.height) : '';
    let rowHtml = '<tr>';
    tm.grid[ri].forEach((tCell, ci) => {
      if (tCell._merged) return;
      const cs = tCell.colspan > 1 ? ` colspan="${tCell.colspan}"` : '';
      const rs = tCell.rowspan > 1 ? ` rowspan="${tCell.rowspan}"` : '';
      const colW = colWidths[ci] ? `width:${colWidths[ci]}%` : '';
      const cbs = tCell.borderStyle != null ? tCell.borderStyle : bsty;
      const cbw = tCell.borderWidth != null ? tCell.borderWidth : bw;
      const cbc = tCell.borderColor != null ? tCell.borderColor : bc;
      const titleAttr = tCell.isTitle ? ' data-title="true"' : '';
      const fontWeight = tCell.isTitle ? 'font-weight:bold;' : '';
      const styles = [
        cbs === 'none' ? 'border:none' : `border:${cbw}px ${cbs} ${cbc}`,
        `background-color:${tCell.bgColor || '#ffffff'}`,
        `padding:${tCell.padding || 8}px`,
        `text-align:${tCell.align || 'left'}`,
        `vertical-align:${tCell.valign || 'top'}`,
        fontWeight,
        colW,
        rowH ? `height:${rowH}px` : '',
      ].filter(Boolean).join(';');

      const key = `${ri}-${ci}`;
      const children = childMap[key] || [];
      let inner = '';
      if (children.length > 0) {
        inner = children.map((child) => renderCellContent(child)).join('');
      } else if (tCell.component) {
        // Handle inline component in table cell
        inner = tCell.content || '&nbsp;';
      } else {
        inner = tCell.content || '&nbsp;';
      }
      rowHtml += `<td${cs}${rs}${titleAttr} style="${styles}">${inner}</td>`;
    });
    rowHtml += '</tr>';
    return rowHtml;
  };

  const titleRows = [];
  const dataRows = [];
  tm.grid.forEach((row, ri) => {
    const hasTitle = row.some((c) => c.isTitle && !c._merged);
    if (hasTitle) titleRows.push(ri);
    else dataRows.push(ri);
  });

  const loopCondsData = loopConds.length > 0 ? ` data-table-loop='${escapeHtml(JSON.stringify(loopConds))}'` : '';
  let html = `<table width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" data-comp-table="true"${loopCondsData} style="border-collapse:collapse;width:100%;mso-table-lspace:0pt;mso-table-rspace:0pt;">`;

  const ifConds = loopConds.filter((c) => c.type === 'if');
  const rangeConds = loopConds.filter((c) => c.type === 'range');
  let prefix = '';
  let suffix = '';

  if (loopConds.length > 0 && titleRows.length > 0) {
    // {{if}} wraps the entire table (titles + data)
    ifConds.forEach((cond) => { prefix += `{{if .${cond.value}}}\n`; });
    ifConds.forEach(() => { suffix += '\n{{end}}'; });
    // Title rows rendered first (NOT iterated by range)
    titleRows.forEach((ri) => { html += buildTableRow(ri); });
    // {{range}} wraps only data rows
    rangeConds.forEach((cond) => { html += `\n{{range .${cond.value}}}`; });
    dataRows.forEach((ri) => { html += buildTableRow(ri); });
    rangeConds.forEach(() => { html += '\n{{end}}'; });
  } else if (loopConds.length > 0) {
    // No title rows — {{if}} wraps entire table, {{range}} wraps all rows inside
    ifConds.forEach((cond) => { prefix += `{{if .${cond.value}}}\n`; });
    ifConds.forEach(() => { suffix += '\n{{end}}'; });
    rangeConds.forEach((cond) => { html += `\n{{range .${cond.value}}}`; });
    tm.grid.forEach((row, ri) => { html += buildTableRow(ri); });
    rangeConds.forEach(() => { html += '\n{{end}}'; });
  } else {
    tm.grid.forEach((row, ri) => { html += buildTableRow(ri); });
  }

  html += '</table>';
  return prefix + html + suffix;
};

const renderLoop = (cell) => {
  const conditions = cell.loopConditions || [];
  if (conditions.length === 0) return '';
  let text = '';
  conditions.forEach((cond) => {
    if (cond.type === 'end') {
      text += '{{end}}';
    } else {
      text += `{{${cond.type} .${cond.value || ''}}}`;
    }
  });
  return text;
};

const renderSpacer = (cell) => {
  const { height = 40 } = cell;
  return `<table cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;"><tr><td height="${height}" style="height: ${height}px; font-size: 1px; line-height: 1px; mso-line-height-rule: exactly;">&nbsp;</td></tr></table>`;
};

const renderCellContent = (cell, context = 'display') => {
  switch (cell.type) {
    case CELL_TYPES.BUTTON:
      return renderButton(cell);
    case CELL_TYPES.DIVIDER:
      return renderDivider(cell);
    case CELL_TYPES.SOCIAL:
      return renderSocial(cell);
    case CELL_TYPES.IMAGE:
      return renderImage(cell);
    case CELL_TYPES.SPACER:
      return renderSpacer(cell);
    case CELL_TYPES.TABLE:
      return cell.tableModel ? renderTableWithChildren(cell, cell._children || []) : '';
    case CELL_TYPES.LOOP:
      return renderLoop(cell);
    case CELL_TYPES.HTML:
      return preserveLineBreaks(cell.content || '');
    case CELL_TYPES.TEXT:
    default:
      return renderText(cell);
  }
};

const clusterIntoColumns = (cells) => {
  const sorted = [...cells].sort((a, b) => a.x - b.x);
  const columns = [];
  for (const cell of sorted) {
    let placed = false;
    for (const col of columns) {
      const colLeft = Math.min(...col.map((c) => c.x));
      const colRight = Math.max(...col.map((c) => c.x + c.width));
      const overlapStart = Math.max(colLeft, cell.x);
      const overlapEnd = Math.min(colRight, cell.x + cell.width);
      const overlap = overlapEnd - overlapStart;
      if (overlap > cell.width * 0.5) {
        col.push(cell);
        placed = true;
        break;
      }
    }
    if (!placed) {
      columns.push([cell]);
    }
  }
  columns.sort((a, b) => Math.min(...a.map((c) => c.x)) - Math.min(...b.map((c) => c.x)));
  return columns;
};

const buildCellTd = (cell) => {
  const cellWidth = Math.round(cell.width);
  const cellHeight = Math.round(cell.height);
  const styles = cell.styles || {};
  const isComponent = ['button', 'divider', 'social'].includes(cell.type);
  const zIndex = cell.zIndex || 1;
  const bgc = isComponent ? 'transparent' : (styles.backgroundColor || 'transparent');
  const bgAttr = bgc !== 'transparent' ? ` bgcolor="${bgc}"` : '';
  const tdStyleParts = [];
  tdStyleParts.push(`width: ${cellWidth}px`);
  tdStyleParts.push(`max-width: ${cellWidth}px`);
  tdStyleParts.push(`padding: ${isComponent ? '0' : (styles.padding || '8px')}`);
  if (bgc !== 'transparent') tdStyleParts.push(`background-color: ${bgc}`);
  tdStyleParts.push(`color: ${styles.color || '#333333'}`);
  tdStyleParts.push(`font-size: ${styles.fontSize || '14px'}`);
  tdStyleParts.push(`font-family: ${styles.fontFamily || 'Arial, sans-serif'}`);
  tdStyleParts.push(`line-height: ${styles.lineHeight || '1.5'}`);
  tdStyleParts.push(`text-align: ${styles.textAlign || 'left'}`);
  tdStyleParts.push('border: none');
  tdStyleParts.push('word-wrap: break-word');
  tdStyleParts.push('overflow-wrap: break-word');
  tdStyleParts.push('word-break: break-word');
  let extraAttrs = '';
  const encodeAttr = (str) => str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  if (cell.type === CELL_TYPES.TABLE && cell.tableModel) {
    const tmJson = encodeAttr(JSON.stringify(cell.tableModel));
    const childJson = encodeAttr(JSON.stringify((cell._children || []).map((ch) => {
      const { _children, ...rest } = ch; return rest;
    })));
    extraAttrs = ` data-table-model="${tmJson}" data-child-cells="${childJson}"`;
  }
  if (cell.type === CELL_TYPES.LOOP && cell.loopConditions) {
    const lcJson = encodeAttr(JSON.stringify(cell.loopConditions));
    extraAttrs = ` data-loop-conditions="${lcJson}"`;
  }
  const metaAttrs = ` data-cell-id="${cell.id}" data-type="${cell.type}" data-x="${Math.round(cell.x)}" data-y="${Math.round(cell.y)}" data-w="${cellWidth}" data-h="${cellHeight}" data-z="${zIndex}" data-allow-overlap="${cell.allowOverlap || false}"${extraAttrs}`;
  return `<td width="${cellWidth}"${bgAttr} valign="top"${metaAttrs} style="${tdStyleParts.join('; ')};">${renderCellContent(cell)}</td>`;
};

export const cellsToHtml = (schema, options = {}) => {
  const { triggerMode = false } = options;
  if (!schema || !schema.cells || schema.cells.length === 0) {
    return '';
  }

  const { cells: rawCells, bgColor = '#ffffff', align = 'center' } = schema;

  // Pre-process: find child components inside TABLE cells, exclude from main layout
  const tableChildIds = new Set();
  const tableChildrenMap = new Map(); // tableCell.id → [childCells]
  const tableCellsList = rawCells.filter((c) => c.type === CELL_TYPES.TABLE && c.tableModel);
  tableCellsList.forEach((tc) => {
    const children = findChildrenInTable(tc, rawCells);
    tableChildrenMap.set(tc.id, children);
    children.forEach((ch) => tableChildIds.add(ch.id));
  });
  // Attach _children to copies of TABLE cells for rendering
  const cells = rawCells
    .filter((c) => !tableChildIds.has(c.id))
    .map((c) => (tableChildrenMap.has(c.id) ? { ...c, _children: tableChildrenMap.get(c.id) } : c));

  const minX = Math.floor(Math.min(...cells.map((c) => c.x)));
  const maxX = Math.ceil(Math.max(...cells.map((c) => c.x + c.width)));
  const minY = Math.floor(Math.min(...cells.map((c) => c.y)));
  const containerWidth = Math.max(1, maxX - minX);
  const sortedByY = [...cells].sort((a, b) => a.y - b.y);
  const rows = [];
  if (sortedByY.length > 0) {
    let currentGroup = [sortedByY[0]];
    let groupMaxY = sortedByY[0].y + sortedByY[0].height;

    for (let i = 1; i < sortedByY.length; i++) {
      const cell = sortedByY[i];
      if (cell.y < groupMaxY - 5) {
        currentGroup.push(cell);
        groupMaxY = Math.max(groupMaxY, cell.y + cell.height);
      } else {
        rows.push({
          y: Math.min(...currentGroup.map((c) => c.y)),
          height: groupMaxY - Math.min(...currentGroup.map((c) => c.y)),
          cells: currentGroup,
        });
        currentGroup = [cell];
        groupMaxY = cell.y + cell.height;
      }
    }
    rows.push({
      y: Math.min(...currentGroup.map((c) => c.y)),
      height: groupMaxY - Math.min(...currentGroup.map((c) => c.y)),
      cells: currentGroup,
    });
  }

  let lastYEnd = minY;
  let innerRowsHtml = '';

  rows.forEach((row) => {
    // In trigger mode, LOOP-only rows output raw template text (no HTML wrappers)
    if (triggerMode && row.cells.length === 1 && row.cells[0].type === CELL_TYPES.LOOP) {
      const loopCell = row.cells[0];
      const conditions = loopCell.loopConditions || [];
      conditions.forEach((cond) => {
        if (cond.type === 'end') {
          innerRowsHtml += '{{end}}\n';
        } else {
          innerRowsHtml += `{{${cond.type} .${cond.value || ''}}}\n`;
        }
      });
      lastYEnd = row.y + row.height;
      return;
    }

    const gap = row.y - lastYEnd;
    if (gap > 0) {
      innerRowsHtml += `        <tr><td height="${Math.round(gap)}" style="height: ${Math.round(gap)}px; font-size: 1px; line-height: 1px; mso-line-height-rule: exactly; padding: 0; border: none;" colspan="1">&nbsp;</td></tr>\n`;
    }

    const columns = clusterIntoColumns(row.cells);

    let tdsHtml = '';
    let currentX = minX;

    columns.forEach((colCells) => {
      const colLeft = Math.round(Math.min(...colCells.map((c) => c.x)));
      const colRight = Math.round(Math.max(...colCells.map((c) => c.x + c.width)));
      const colWidth = colRight - colLeft;

      const leftGap = colLeft - currentX;
      if (leftGap > 0) {
        tdsHtml += `<td width="${leftGap}" style="width: ${leftGap}px; font-size: 0; line-height: 0; padding: 0; border: none; mso-line-height-rule: exactly;">&nbsp;</td>`;
      }

      const sortedByY = [...colCells].sort((a, b) => a.y - b.y);
      const topOffset = Math.round(sortedByY[0].y - row.y);
      const needsNesting = colCells.length > 1 || topOffset > 2;

      if (!needsNesting) {
        tdsHtml += buildCellTd(colCells[0]);
      } else {
        let nestedRows = '';
        if (topOffset > 2) {
          nestedRows += `<tr><td height="${topOffset}" style="height: ${topOffset}px; font-size: 1px; line-height: 1px; padding: 0; border: none; mso-line-height-rule: exactly;">&nbsp;</td></tr>`;
        }
        sortedByY.forEach((cell, idx) => {
          if (idx > 0) {
            const prevCell = sortedByY[idx - 1];
            const gapY = Math.round(cell.y) - Math.round(prevCell.y + prevCell.height);
            if (gapY > 0) {
              nestedRows += `<tr><td height="${gapY}" style="height: ${gapY}px; font-size: 1px; line-height: 1px; padding: 0; border: none; mso-line-height-rule: exactly;">&nbsp;</td></tr>`;
            }
          }
          nestedRows += `<tr>${buildCellTd(cell)}</tr>`;
        });
        tdsHtml += `<td width="${colWidth}" valign="top" style="width: ${colWidth}px; padding: 0; border: none;"><table width="${colWidth}" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; table-layout: fixed; width: ${colWidth}px;">${nestedRows}</table></td>`;
      }

      currentX = colRight;
    });

    const rightGap = (minX + containerWidth) - currentX;
    if (rightGap > 0) {
      tdsHtml += `<td width="${rightGap}" style="width: ${rightGap}px; font-size: 0; line-height: 0; padding: 0; border: none; mso-line-height-rule: exactly;">&nbsp;</td>`;
    }

    innerRowsHtml += `        <tr>\n          <td style="padding: 0; border: none;" width="${containerWidth}">\n            <table width="${containerWidth}" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; table-layout: fixed; width: ${containerWidth}px;">\n              <tr>${tdsHtml}</tr>\n            </table>\n          </td>\n        </tr>\n`;

    lastYEnd = row.y + row.height;
  });

  const outerAlign = align === 'left' ? 'left' : align === 'right' ? 'right' : 'center';
  const marginStyle =
    outerAlign === 'left' ? '0 auto 0 0' : outerAlign === 'right' ? '0 0 0 auto' : '0 auto';

  const html = `<table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="${bgColor}" style="background-color: ${bgColor}; width: 100%;">
  <tr>
    <td align="${outerAlign}" valign="top" bgcolor="${bgColor}" style="background-color: ${bgColor}; padding: 20px 0;">
      <!--[if mso]><table cellpadding="0" cellspacing="0" border="0" width="${containerWidth}" align="${outerAlign}"><tr><td><![endif]-->
      <table width="${containerWidth}" cellpadding="0" cellspacing="0" border="0" bgcolor="${bgColor}" align="${outerAlign}" data-editor-canvas="true" style="border-collapse: collapse; table-layout: fixed; font-family: Arial, sans-serif; margin: ${marginStyle}; width: ${containerWidth}px; background-color: ${bgColor};">
${innerRowsHtml}      </table>
      <!--[if mso]></td></tr></table><![endif]-->
    </td>
  </tr>
</table>`;

  return html;
};

const stripDataAttrsRegex = (html) => {
  if (!html) return '';
  let result = html;
  result = result.replace(/\s+data-[-a-z0-9]+="[^"]*"/gi, '');
  result = result.replace(/\s+data-[-a-z0-9]+='[^']*'/gi, '');
  result = result.replace(/\s+contenteditable="[^"]*"/gi, '');
  return result;
};

export const cellsToTableHtml = (schema) => {
  const fullHtml = cellsToHtml(schema, { triggerMode: true });
  return stripDataAttrsRegex(fullHtml);
};

export const sanitizeHtmlForSave = (html) => {
  if (!html) return '';
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    doc
      .querySelectorAll('.q-del, .cell-resize-handle, .cell-drag-handle')
      .forEach((el) => el.remove());
    doc.querySelectorAll('[data-selected], [data-editing], [contenteditable]').forEach((el) => {
      el.removeAttribute('data-selected');
      el.removeAttribute('data-editing');
      el.removeAttribute('contenteditable');
    });
    return doc.body.innerHTML;
  } catch {
    return html;
  }
};

export const stripDataAttributes = (html) => {
  if (!html) return '';
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    doc
      .querySelectorAll('.q-del, .cell-resize-handle, .cell-drag-handle')
      .forEach((el) => el.remove());
    doc.querySelectorAll('*').forEach((el) => {
      const attrs = Array.from(el.attributes);
      attrs.forEach((attr) => {
        if (attr.name.startsWith('data-')) {
          el.removeAttribute(attr.name);
        }
      });
      el.removeAttribute('contenteditable');
    });
    return doc.body.innerHTML;
  } catch {
    return html;
  }
};

export const cellsToTriggerHtml = (schema) => {
  const fullHtml = cellsToHtml(schema, { triggerMode: true });
  return stripDataAttrsRegex(fullHtml);
};

export const cellsToPreviewHtml = cellsToHtml;

export default cellsToHtml;
